// --------------------------------------------------------------------------
// # Report as email form
// --------------------------------------------------------------------------
// Author:      RSPB
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
	var ref = { $root: options.context, $document: jQuery(document) };
	var state = {};

	function render() {
		if (state.age > -1) {
			// find all elements with age restriction
			ref.$document.find('[data-underage-hide]').each(function () {
				// depending on the current age show/hide elements
				if (state.age < $(this).data('underage-hide') && state.underAge.toLowerCase() == 'yes') {
					$(this).hide();
				} else {
					$(this).show();
				}
			});
		}
	}

	function calculateAge(day, month, year) {
		if (day == '' || month == '' || year == '') {
			return -1;
		}
		// JavaScript counts months from 0 to 11, subtract 1 from the input
		var diff = Date.now() - new Date(year, month - 1, day).getTime();
		return Math.abs(new Date(diff).getUTCFullYear() - 1970);
	}

	function getState() {
		return {
			underAge: ref.$inputUnderAge.filter(':checked').val(),
			age: calculateAge(ref.$dobDay.val(), ref.$dobMonth.val(), ref.$dobYear.val())
		};
	}

	function onAgeChange(event) {
		state = getState();

		if (state.underAge == 'Yes' || state.underAge == 'yes') {
			if (!parseInt(ref.$dobDay.val()) > 0 || !parseInt(ref.$dobMonth.val()) > 0 || !parseInt(ref.$dobYear.val()) > 0) {
				state.showDobError = true;
			}
		}

		// Trigger render
		render();
	}

	function init() {
		ref.$dobDay = ref.$root.find('[data-binding="contact-details-dob-day"]');
		ref.$dobMonth = ref.$root.find('[data-binding="contact-details-dob-month"]');
		ref.$dobYear = ref.$root.find('[data-binding="contact-details-dob-year"]');
		ref.$inputUnderAge = ref.$root.find('input[name="ContactDetails.UnderAgeString"]');
		ref.$optionsUnderAge = ref.$root.find('[data-binding="contact-details-underage"]');

		if (ref.$root.find('[data-binding="contact-details-underage"]').first().is(':checked')) {
			ref.$root.find('[data-binding="report-as-email-dob"]').show();
			ref.$root.find('[data-binding="under18-hide"]').hide('slow');
		}

		ref.$optionsUnderAge.on('change', onAgeChange);
		ref.$dobDay.on('change', onAgeChange);
		ref.$dobMonth.on('change', onAgeChange);
		ref.$dobYear.on('change', onAgeChange);

		ref.$root.find('[data-binding="contact-details-underage"]').on('change', function () {
			if ($(this).is(ref.$root.find('[data-binding="contact-details-underage"]').last())) {
				ref.$root.find('[data-binding="report-as-email-dob"]').hide('slow');
				ref.$root.find('[data-binding="under18-hide"]').show('slow');
			} else {
				ref.$root.find('[data-binding="report-as-email-dob"]').show('slow');
				ref.$root.find('[data-binding="under18-hide"]').hide('slow');
			}
		});
	}

	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/contact-show-dob.js
// module id = 486
// module chunks = 0